// ================================================================
// CF7 changeバリデーション無効化
// ================================================================
export function initFormValidationControl() {
  const form = document.querySelector('.wpcf7-form');
  if (!form) return;

  form.addEventListener('change', (e) => {
    e.stopImmediatePropagation();
  }, true);

  // チェックボックス・セレクトのバリデーションメッセージを差し替え
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (!node.classList?.contains('wpcf7-not-valid-tip')) continue;

        const wrap = node.closest('.wpcf7-form-control-wrap');
        if (!wrap) continue;

        if (wrap.querySelector('input[type="checkbox"]') || wrap.querySelector('select')) {
          node.textContent = '選択してください';
        }
      }
    }
  });

  observer.observe(form, { childList: true, subtree: true });
}
